import { Component } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { AuthenticationService } from '@shared/services/authentication.service';
import { InternalAnalyticsService } from '@shared/services/internalAnalytics.service';
import { ListOfSpacesBaseComponent } from '@shared/base-components/list-of-spaces.base.component';
import { AddParticipantDialogComponent } from '@shared/components/add-participant-dialog/add-participant-dialog.component';
import { Learnspace, LearnspaceUserRole } from '@shared/models';

@Component({
  selector: 'list-of-programs',
  templateUrl: './list-of-programs.component.html',
  styleUrls: ['./list-of-programs.component.scss'],
  animations: fuseAnimations
})
export class ListOfProgramsComponent extends ListOfSpacesBaseComponent {
  public isProcessing: boolean;
  constructor(
    protected _courseApiService: CoursesAPIService,
    protected _authservice: AuthenticationService,
    protected _dialog: MatDialog,
    protected _router: Router,
    protected _activatedRoute: ActivatedRoute,
    protected _currentHub: CurrentHubService,
    protected _internalAnalyticsService: InternalAnalyticsService,
    private _authService: AuthenticationService
  ) {
    super(_courseApiService, _authservice, _dialog, _router, _activatedRoute, _currentHub, _internalAnalyticsService);
    this.isProcessing = false;
  }

  showLsParticipants(learnspace: Learnspace, event: any): void {
    event.stopPropagation();
    const user = this._authService.wondaUser.id;
    this._dialog.open(AddParticipantDialogComponent, {
      width: '500px', height: '60vh',
      data: { learnspace: learnspace, user_id: user }
    }
    );
  }
  duplicateSpace(learnspace: Learnspace) {
    this.isProcessing = true;
    this._courseApiService.duplicateLearnspace(learnspace.id, null, true).subscribe(() => {
      this.isProcessing = false;
      this.listUpdate.emit({ shouldReloadList: true });
    })
  }

  enterLearnspace(ls: Learnspace): void {
    if (this.isArchived(ls)) {
      return;
    }
    if (this._currentHub.canAdminCurrentHub() || ls.lsRole == LearnspaceUserRole.contributor) {
      this._router.navigate([`../${ls.id}`], { relativeTo: this._activatedRoute });
    } else if (ls.lsRole == LearnspaceUserRole.learner) {
      this._router.navigate([], { relativeTo: this._activatedRoute, queryParams: { pl: ls.id }, queryParamsHandling: 'merge' });
    } else {
      this.requestLearnspaceAccess(ls);
    }
  }
}
